import { render, staticRenderFns } from "./ResponsibilityOtherDetails.vue?vue&type=template&id=458b6342"
import script from "./ResponsibilityOtherDetails.vue?vue&type=script&lang=js"
export * from "./ResponsibilityOtherDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports